module.exports = __webpack_public_path__ + "static/images/get-it-on-google-play.671b2236e9d190746d9f534167277b0b.png";